/* CSV serialisation + the two export row contracts.
   Extracted verbatim from artifact.html (toCSV in <script id="logic">, the export
   column maps in <script id="app">). Column names and order are a contract — the
   streamed server exports in phase 3 must emit exactly these. */

import { expectedCtr } from "./score.js";
import { ACTIONS, EFFORT, FORMAT_HINT, RECOVER } from "./actions.js";

export const BOM = "\uFEFF";

export function toCSV(rows) {
  if (!rows.length) return "";
  const cols = Object.keys(rows[0]);
  const esc = v => '"' + String(v == null ? "" : v).replace(/"/g, '""') + '"';
  return [cols.join(","), ...rows.map(r => cols.map(c => esc(r[c])).join(","))].join("\n");
}

/* Filtered query export — 21 columns. */
export function exportRow(d) {
  return {
    query: d.q, bucket: d.bucket, detected_pattern: d.pattern, conversation_stage: d.stage || "", by: d.by,
    signal_tier: d.tier || "", conversational_score: d.cscore, confidence: d.conf + "%",
    question_type: d.qt || "", intent: d.intent || "", user_need: d.need || "", journey_stage: d.journey || "",
    topic: d.topic || "", subtopic: d.sub || "", page: d.page || "",
    ai_page_match: d.aiMatch || "", on_ai_page: d.aiPage ? "yes" : "",
    opportunity_score: d.oscore != null ? d.oscore : "", clicks: d.clicks, impressions: d.imp,
    ctr: d.ctr + "%", position: d.pos,
  };
}

export const EXPORT_COLUMNS = Object.keys(exportRow({}));

/* Per-action work order — 14 columns. `ctr_gap` is emitted for recover actions only,
   because capture actions have no defensible click projection. */
export function workOrderRows(k, qs, packets = []) {
  const pmap = {};
  packets.forEach(p => p.members.forEach(m => { pmap[m.q] = p; }));
  return qs.map(d => {
    const p = pmap[d.q];
    const exp = expectedCtr(d.pos);
    return {
      action: ACTIONS[k].title, priority_effort: EFFORT[k][1], query: d.q,
      packet: p ? p.h1 : "",
      target: p && p.target ? p.target : (RECOVER[k] ? (d.page || "ranking page") : "new content"),
      format: FORMAT_HINT[k] || "", conversation_stage: d.stage || "", journey_stage: d.journey || "",
      clicks: d.clicks, impressions: d.imp, ctr: d.ctr + "%", position: d.pos,
      expected_ctr_at_pos: exp.toFixed(1) + "%",
      ctr_gap: RECOVER[k] ? Math.max(0, exp - d.ctr).toFixed(1) + "%" : "",
    };
  }).sort((a, b) => b.impressions - a.impressions);
}
